import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';

/**
 * Esta configuração é PÚBLICA por natureza: ela viaja no pacote JS que chega a
 * todo navegador. Ela identifica o projeto, não autoriza nada.
 *
 * Quem protege os dados é o firestore.rules. Segredo de verdade — chave da
 * OpenAI, client_secret do Mercado Livre, credencial SMTP — nunca aparece aqui:
 * fica em variável de ambiente de Cloud Function.
 */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const faltando = Object.entries(firebaseConfig)
  .filter(([, v]) => !v)
  .map(([k]) => k);
if (faltando.length > 0) {
  throw new Error(
    `Configuração do Firebase incompleta: ${faltando.join(', ')}. ` +
      'Copie o .env.example para .env na raiz do projeto.',
  );
}

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'southamerica-east1');

// Desenvolvimento contra os emuladores: as regras que rodam aqui são as mesmas
// do firestore.rules, então dá para exercitar o sistema sem tocar em produção.
if (import.meta.env.VITE_USAR_EMULADOR === '1') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}
